import api from './api';
import API_ROUTES from './apiRoutes';

const adminService = {
  getPendingApprovals: async (params = {}) => {
    const {
      page = 1,
      limit = 10,
      sortOrder = 'asc',
      role = 'player',
      sortBy = 'firstName',
    } = params;

    const response = await api.get(API_ROUTES.SUPER_ADMIN.PENDING_APPROVALS, {
      params: {
        page,
        limit,
        sortOrder,
        role,
        sortBy,
      },
    });
    return response.data;
  },

  approveUser: async (id) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.APPROVE(id), {});
    return response.data;
  },

  rejectUser: async (id, reason) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.REJECT(id), {
      reason: reason || 'No reason provided',
    });
    return response.data;
  },

  getUserDetails: async (id) => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.USER_DETAILS(id));
    return response.data;
  },

  getUsersByRoles: async (params = {}) => {
    const {
      page = 1,
      limit = 10,
      role = 'scout',
      search,
      teamId,
    } = params;

    const queryParams = { page, limit, role };
    if (search) queryParams.search = search;
    if (teamId) queryParams.teamId = teamId;

    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_USERS_BY_ROLES, {
      params: queryParams,
    });
    return response.data;
  },

  getManualEditsUsers: async (params = {}) => {
    const {
      page = 1,
      limit = 20,
      role = 'player',
      search,
    } = params;

    const queryParams = { page, limit, role };
    if (search) queryParams.search = search;

    const response = await api.get(API_ROUTES.SUPER_ADMIN.MANUAL_EDITS_USERS, {
      params: queryParams,
    });
    return response.data;
  },

  updateUserProfile: async (id, profileData) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.UPDATE_USER(id), profileData);
    return response.data;
  },

  deleteUserVideo: async (userId, videoId) => {
    const response = await api.delete(API_ROUTES.SUPER_ADMIN.DELETE_USER_VIDEO(userId, videoId));
    return response.data;
  },

  uploadUserVideo: async (id, videoFile) => {
    const formData = new FormData();
    formData.append('videos', videoFile);
    const response = await api.post(API_ROUTES.SUPER_ADMIN.UPLOAD_USER_VIDEO(id), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000, // 5 minutes for video upload
    });
    return response.data;
  },

  // Video Request APIs
  getVideoRequests: async () => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_VIDEO_REQUESTS);
    return response.data;
  },

  // Reactivation Request APIs
  getReactivationRequests: async () => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_REACTIVATION_REQUESTS);
    return response.data;
  },

  getCancellationRequests: async () => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.GET_CANCELLATION_REQUESTS);
    return response.data;
  },

  updateReactivationRequest: async (id, status) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.UPDATE_REACTIVATION_REQUEST(id), { status });
    return response.data;
  },

  updateVideoRequest: async (id, status) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.UPDATE_VIDEO_REQUEST(id), { status });
    return response.data;
  },

  // Manual Edits > Team Profiles
  getTeamsForEdit: async (params = {}) => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.TEAMS, { params });
    return response.data;
  },

  getTeamRosterForEdit: async (id) => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.TEAM_ROSTER(id));
    return response.data;
  },

  // formData: any team field (text fields, rank, isActive, logoUrl, topPerformerPlayerId,
  // topPerformerStats), plus teamLogo (image file) to replace the logo
  updateTeam: async (id, formData) => {
    const response = await api.patch(API_ROUTES.SUPER_ADMIN.UPDATE_TEAM(id), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Homepage social posts (Home Page tab)
  getSocialPosts: async () => {
    const response = await api.get(API_ROUTES.SUPER_ADMIN.SOCIAL_POSTS);
    return response.data;
  },

  // formData: platform, url, headline, thumbnail (image file)
  createSocialPost: async (formData) => {
    const response = await api.post(API_ROUTES.SUPER_ADMIN.SOCIAL_POSTS, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  deleteSocialPost: async (id) => {
    const response = await api.delete(API_ROUTES.SUPER_ADMIN.DELETE_SOCIAL_POST(id));
    return response.data;
  },
};

export default adminService;
